const quickViewWarpper = document.getElementById("quickViewWrapper");

function closeQuickViewModal() {
  if (!quickViewWarpper) return;

  const activeButton = document.querySelector("quick-view-modal button.active");
  document.body.classList.remove("overflow-hidden");
  quickViewWarpper.classList.remove("show__modal");

  if (activeButton) {
    if (typeof removeTrapFocus === "function") removeTrapFocus(activeButton);
    activeButton.classList.remove("active");
  }
}

function bindQuickViewGlobalListeners() {
  if (!quickViewWarpper || quickViewWarpper.dataset.listenersBound === "true") {
    return;
  }

  quickViewWarpper.dataset.listenersBound = "true";
  quickViewWarpper.addEventListener("keyup", (event) => {
    if (event.code === "Escape") closeQuickViewModal();
  });

  document.addEventListener("click", (event) => {
    if (!quickViewWarpper.classList.contains("show__modal")) return;
    if (
      event.target.closest(".quick_view__body") ||
      event.target.closest("quick-view-modal")
    ) {
      return;
    }
    closeQuickViewModal();
  });
}

class QuickViewModal extends HTMLElement {
  constructor() {
    super();
    this.onClickQuickViewModal = this.onClickQuickViewModal.bind(this);
    this.addEventListener("click", this.onClickQuickViewModal);
    bindQuickViewGlobalListeners();
  }

  async onClickQuickViewModal(event) {
    const quickViewModalButton = event.target.closest("button");
    if (!quickViewModalButton || !this.contains(quickViewModalButton) || !quickViewWarpper) {
      return;
    }

    const productHandle = quickViewModalButton.dataset.productHandle;
    if (!productHandle || quickViewModalButton.classList.contains("loading")) return;

    quickViewModalButton.classList.add("loading");

    try {
      const response = await fetch(
        `/products/${encodeURIComponent(productHandle)}?view=quickview`
      );
      if (!response.ok) {
        throw new Error(`Quick view request failed: ${response.status}`);
      }

      quickViewWarpper.innerHTML = await response.text();

      if (window.Shopify?.PaymentButton) Shopify.PaymentButton.init();

      document.body.classList.add("overflow-hidden");
      quickViewWarpper.classList.add("show__modal");
      quickViewModalButton.classList.add("active");

      if (typeof trapFocus === "function") trapFocus(quickViewWarpper);
    } catch (error) {
      console.error("Unable to open quick view", error);
    } finally {
      quickViewModalButton.classList.remove("loading");
    }
  }
}

if (!customElements.get("quick-view-modal")) {
  customElements.define("quick-view-modal", QuickViewModal);
}

class QuickViewCloseTag extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", closeQuickViewModal);
  }
}

if (!customElements.get("quick-view-close")) {
  customElements.define("quick-view-close", QuickViewCloseTag);
}

class QuickVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.onVariantChange = this.onVariantChange.bind(this);
    this.addEventListener("change", this.onVariantChange);
    this.renderController = null;
    this.renderRequestId = 0;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateOptionsParent();
    this.updateMasterId();
    this.updateVariantStatuses();
    this.getPreOrderVariantData();

    if (!this.currentVariant) {
      this.abortPendingRender();
      this.setUnavailable();
      return;
    }

    this.updateMedia();
    this.updateVariantInput();
    this.updatePurchaseControls(this.currentVariant);
    this.renderProductInfo(this.currentVariant);
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateOptionsParent() {
    this.querySelectorAll(".product-form__input--dropdown").forEach((wrapper, index) => {
      const selectedValue = wrapper.querySelector(".form__label span");
      if (selectedValue && this.options[index] !== undefined) {
        selectedValue.textContent = this.options[index];
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      if (!Array.isArray(variant.options)) return false;
      return variant.options.every(
        (option, index) => this.options[index] === option
      );
    });
  }

  updateMedia() {
    if (!this.currentVariant?.featured_media) return;

    const scope = this.closest("#quickViewWrapper") || quickViewWarpper || document;
    const newMedia = scope.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia?.parentElement) return;

    const parent = newMedia.parentElement;
    if (parent.firstElementChild !== newMedia) parent.prepend(newMedia);
    if (typeof parent.scrollTo === "function") parent.scrollTo(0, 0);
  }

  updateVariantInput() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const input = productForm?.querySelector('input[name="id"]');
    if (!input) return;

    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  getSelectedValue(wrapper) {
    const selected = wrapper.querySelector(":checked");
    return selected ? selected.value : null;
  }

  updateVariantStatuses() {
    const wrappers = [...this.querySelectorAll(".product-form__input")];
    if (wrappers.length < 2) return;

    const variants = this.getVariantData();
    wrappers.forEach((wrapper, index) => {
      if (index === 0) return;

      const previousValues = wrappers
        .slice(0, index)
        .map((previousWrapper) => this.getSelectedValue(previousWrapper));

      const availableValues = variants
        .filter((variant) => {
          if (!variant.available || !Array.isArray(variant.options)) return false;
          return previousValues.every(
            (value, optionIndex) => value === null || variant.options[optionIndex] === value
          );
        })
        .map((variant) => variant.options[index]);

      const inputs = [...wrapper.querySelectorAll('input[type="radio"], option')];
      this.setInputAvailability(inputs, availableValues);
    });
  }

  setInputAvailability(inputs, availableValues) {
    inputs.forEach((input) => {
      const value = input.getAttribute("value") || "";
      const isAvailable = availableValues.includes(value);
      const unavailableTemplate =
        window.variantStrings?.unavailableWithOption || "[value] - Unavailable";

      input.textContent = isAvailable
        ? value
        : unavailableTemplate.replace("[value]", value);
      input.dataset.optionAvailable = String(isAvailable);
    });
  }

  async renderProductInfo(variant = this.currentVariant) {
    if (!variant) return;

    this.abortPendingRender();
    this.renderController = new AbortController();
    const requestId = ++this.renderRequestId;
    const requestedVariantId = String(variant.id);

    try {
      const response = await fetch(
        `${this.dataset.url}?variant=${variant.id}&section_id=${this.dataset.section}`,
        { signal: this.renderController.signal }
      );
      if (!response.ok) throw new Error(`Quick variant request failed: ${response.status}`);

      const responseText = await response.text();
      if (
        requestId !== this.renderRequestId ||
        String(this.currentVariant?.id) !== requestedVariantId
      ) {
        return;
      }

      const html = new DOMParser().parseFromString(responseText, "text/html");
      const id = `price-${this.dataset.section}`;
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      destination?.classList.remove("no-js-inline");

      this.syncAddButtonFromServer(html);
      this.updatePurchaseControls(this.currentVariant, this.getPurchaseState(this.currentVariant), false);
    } catch (error) {
      if (error?.name !== "AbortError") {
        console.error("Unable to refresh quick-view variant", error);
      }
    }
  }

  abortPendingRender() {
    this.renderController?.abort();
    this.renderController = null;
  }

  getProductForm() {
    return document.getElementById(`product-form-${this.dataset.section}`);
  }

  getPreorderEnabled() {
    return this.getProductForm()?.closest("product-form")?.dataset.preorderEnabled === "true";
  }

  getPurchaseState(variant = this.currentVariant) {
    if (!variant) return "unavailable";
    if (!variant.available) return "soldout";

    const inventory = this.getPreOrderVariantData()[String(variant.id)] || {};
    const quantity = Number(inventory.qty);

    if (
      this.getPreorderEnabled() &&
      Number.isFinite(quantity) &&
      quantity <= 0 &&
      inventory.inventory_policy === "continue"
    ) {
      return "preorder";
    }

    return "available";
  }

  updatePurchaseControls(
    variant = this.currentVariant,
    state = this.getPurchaseState(variant),
    updateText = true
  ) {
    const productForm = this.getProductForm();
    const addButton = productForm?.querySelector('[name="add"]');
    if (!addButton) return;

    const disabled = state === "soldout" || state === "unavailable";
    addButton.disabled = disabled;
    addButton.dataset.variantAvailable = String(!disabled);
    addButton.dataset.variantId = variant?.id || "";

    if (updateText) {
      const addButtonText =
        addButton.querySelector(".cart--button-text") || addButton;
      addButtonText.textContent = {
        available: window.variantStrings?.addToCart || "Add to cart",
        preorder: window.variantStrings?.preorder || "Preorder",
        soldout: window.variantStrings?.soldOut || "Sold out",
        unavailable: window.variantStrings?.unavailable || "Unavailable",
      }[state];
    }

    const dynamicCheckout = productForm.querySelector(
      ".product-form__dynamic-checkout, .shopify-payment-button"
    );
    if (dynamicCheckout) dynamicCheckout.hidden = disabled;
  }

  syncAddButtonFromServer(html) {
    const destinationForm = this.getProductForm();
    const sourceForm = html.getElementById(`product-form-${this.dataset.section}`);
    const destinationButton = destinationForm?.querySelector('[name="add"]');
    const sourceButton = sourceForm?.querySelector('[name="add"]');
    if (!destinationButton || !sourceButton) return;

    destinationButton.innerHTML = sourceButton.innerHTML;
    destinationButton.disabled = sourceButton.disabled;
  }

  setUnavailable() {
    this.updatePurchaseControls(null, "unavailable");
    document.getElementById(`price-${this.dataset.section}`)?.classList.add("no-js-inline");
  }

  getVariantData() {
    if (this.variantData) return this.variantData;
    const element = this.querySelector("[data-variant]");
    if (!element) return [];

    try {
      this.variantData = JSON.parse(element.textContent);
    } catch (error) {
      console.error("Unable to parse quick-view variant data", error);
      this.variantData = [];
    }
    return this.variantData;
  }

  getPreOrderVariantData() {
    if (this.PreorderVariantData) return this.PreorderVariantData;
    const element = this.querySelector("[data-preorder]");
    if (!element) return {};

    try {
      this.PreorderVariantData = JSON.parse(element.textContent);
    } catch (error) {
      console.error("Unable to parse quick-view preorder data", error);
      this.PreorderVariantData = {};
    }
    return this.PreorderVariantData;
  }
}

if (!customElements.get("quick-variant-selects")) {
  customElements.define("quick-variant-selects", QuickVariantSelects);
}

class QuickVariantRadios extends QuickVariantSelects {
  constructor() {
    super();
    this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.onColorSwatches();
  }

  onColorSwatches() {
    if (!this.dataset.colorSwatch) return;

    const swatchButtons = this.querySelectorAll(
      `fieldset.variant--swatch-${this.dataset.colorSwatch} > label`
    );
    const variantsByValue = Object.values(
      this.getVariantData().reduce((total, variant) => {
        const key = `${variant[this.dataset.colorSwatch]}`;
        if (!total[key]) total[key] = { ...variant, count: 1 };
        else total[key].count += 1;
        return total;
      }, {})
    );

    swatchButtons.forEach((button) => {
      variantsByValue.forEach((variant) => {
        if (variant[this.dataset.colorSwatch] !== button.dataset.value) return;

        if (
          this.dataset.colorSwatchStyle === "image" &&
          variant.featured_image?.src
        ) {
          button.setAttribute(
            "style",
            `--swatch-background-image: url(${variant.featured_image.src}); --swatch-background-color: ${variant[this.dataset.colorSwatch]};`
          );
        } else {
          button.setAttribute(
            "style",
            `--swatch-background-color: ${variant[this.dataset.colorSwatch]};`
          );
        }
      });
    });
  }

  setInputAvailability(inputs, availableValues) {
    inputs.forEach((input) => {
      const isAvailable = availableValues.includes(input.getAttribute("value"));
      input.classList.toggle("disabled", !isAvailable);
      input.setAttribute("aria-disabled", String(!isAvailable));
      input.dataset.optionAvailable = String(isAvailable);
    });
  }

  updateOptions() {
    this.options = this.fieldsets.map((fieldset) => {
      const selected = fieldset.querySelector('input[type="radio"]:checked');
      return selected ? selected.value : null;
    });
  }

  updateOptionsParent() {
    this.fieldsets.forEach((fieldset, index) => {
      const selectedValue = fieldset.querySelector(".form__label span");
      if (selectedValue && this.options[index] !== null) {
        selectedValue.textContent = this.options[index];
      }
    });
  }
}

if (!customElements.get("quick-variant-radios")) {
  customElements.define("quick-variant-radios", QuickVariantRadios);
}
